import { createSelector } from 'reselect'
import { selectPrefersAllMailboxesSectionVisible } from 'ducks/currentUser/selectors/preferences/selectPrefersAllMailboxesSectionVisible'
import { selectPrefersUnifiedInbox } from 'ducks/currentUser/selectors/preferences/selectPrefersUnifiedInbox'
import { selectCurrentQuery } from 'ducks/searches/selectors/selectCurrentQuery'

export const selectIsMailboxIndicatorNeeded = createSelector(
  selectCurrentQuery,
  selectPrefersUnifiedInbox,
  selectPrefersAllMailboxesSectionVisible,
  (currentQuery, perefersUnified, prefersAllMailbox) => {
    if (perefersUnified) return true
    if (prefersAllMailbox) return currentQuery.channel?.length !== 1
    if (prefersAllMailbox) return true
    return false
  }
)
